import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, Renderer2, RendererFactory2, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { DomSanitizer, Meta, SafeHtml, SafeResourceUrl, Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { PerfilService } from 'src/app/services/perfil.service';
import { TarjetaService } from 'src/app/services/tarjeta.service';
import { environment } from 'src/environments/environment';
import { TarjetaResolveData } from 'src/app/resolvers/tarjeta.resolver';
import { NotificationService, Notification } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-tarjeta',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    NgxSpinnerModule,
  ],
  templateUrl: './tarjeta.component.html',
  styleUrl: './tarjeta.component.scss'
})
export class TarjetaComponent implements OnInit, OnChanges {

  @Input() tarjeta: any;
  @Input() profile: any;
  urlBase: string = environment.apiEndpoint;
  safeVideoUrl!: SafeResourceUrl;
  private renderer: Renderer2;
  panelAbierto = false;
  googleWalletUrl: string = '';
  cargoHTML!: SafeHtml;
  textoHTML!: SafeHtml;
  private isBrowserEnv = false;

  isSportsClub = false;
  sportsData: any = null;

  get vehicleDetails(): { label: string; value: any }[] {
    if (Number(this.tarjeta?.idTipoTarjeta) !== 3) return [];
    const vehiculo = this.tarjeta?.fichaMotor?.vehiculo;
    if (!vehiculo) return [];
    return [
      { label: 'Año', value: vehiculo.year },
      { label: 'Color', value: vehiculo.color },
      { label: 'Marca', value: vehiculo.brandName },
      { label: 'Modelo', value: vehiculo.modelName },
      { label: 'Versión', value: vehiculo.version },
      { label: 'VIN', value: vehiculo.vinNumber },
      { label: 'N° motor', value: vehiculo.engineNumber },
      { label: 'Combustible', value: vehiculo.fuel },
      { label: 'Transmisión', value: vehiculo.transmission },
    ].filter(item => item.value !== null && item.value !== undefined && item.value !== '');
  }



  mostrarModal: boolean = false;
  urlParaCompartir: string = '';
  urlWhatsapp: string = '';
  urlEmail: string = '';
  instruction: string = '';

  // Notifications
  notifications: Notification[] = [];
  unreadCount: number = 0;
  showNotificationsPanel: boolean = false;


  formExtra = {
    nombre: '',
    telefono: '',
    correo: '',
    empresa: '',
  };
  termsAccepted = false;

  isExpired: boolean = false;
  isLoading: boolean = false;
  loadError: string = '';
  bannerLoaded = false;
  profileImageLoaded = false;
  logoLoaded = false;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private sanitizer: DomSanitizer,
    private perfilService: PerfilService,
    private tarjetaService: TarjetaService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.isBrowserEnv = isPlatformBrowser(this.platformId);
  }



  ngOnInit(): void {
    const resolved = this.route.snapshot.data['tarjeta'] as TarjetaResolveData | undefined;
    const hasResolved = !!resolved?.tarjeta || !!resolved?.perfil;

    if (resolved?.tarjeta) {
      this.resetImageLoadingState();
      this.tarjeta = resolved.tarjeta;
      this.setCargoHTML(this.tarjeta?.cargo || '');
      this.updateMetaTags();
      this.checkExpiration();
    }

    if (resolved?.perfil) {
      this.profile = resolved.perfil;
      this.ngOnChanges();
      this.setTextoHTML(this.profile?.texto || '');
    }

    if (hasResolved) {
      this.checkForNotifications();
    }

    if (!hasResolved) {
      this.route.paramMap.subscribe(params => {
        const idTarjeta = params.get('id');
        if (idTarjeta && idTarjeta !== '0' && !this.profile) {
          this.loadTarjetaData(idTarjeta);
        } else {
          // ... test mockup code ...
          if (!this.tarjeta) {
            const fechaActual = new Date();
            const fechaFutura = new Date(fechaActual);
            fechaFutura.setDate(fechaFutura.getDate() + 15);
            this.tarjeta = {
              id: "test",
              nombre: "Juan Perez",
              cargo: "Gerente de Ventas",
              telefono: "123456789",
              wsp: "987654321",
              correo: "juan@example.com",
              direccion: "Temuco, Chile",
              imgProfile: "assets/images/logos/profile.webp",
              linkProfile: "https://v6card.com/",
              linkInteres: "https://interes.com",
              paginaWeb: "https://empresa.com",
              endDate: fechaFutura.toISOString()
            };
          }
          this.isLoading = false;
        }
      });
    }
  }

  private loadTarjetaData(codigo: string): void {
    this.isLoading = true;
    this.loadError = '';

    forkJoin({
      tarjeta: this.tarjetaService.getTarjetaByCode(codigo),
      perfil: this.perfilService.getPerfilByCodeTarjeta(codigo),
    }).subscribe({
      next: ({ tarjeta, perfil }) => {
        this.resetImageLoadingState();
        this.tarjeta = tarjeta;
        this.profile = perfil;
        this.isLoading = false;
        this.setCargoHTML(this.tarjeta?.cargo || '');
        this.setTextoHTML(this.profile?.texto || '');
        this.ngOnChanges();
        this.updateMetaTags();
        this.checkExpiration();
        this.checkForNotifications();
      },
      error: (err) => {
        this.isLoading = false;
        this.loadError = 'No se pudo cargar la tarjeta. Intenta nuevamente.';
        console.error('Error al cargar la tarjeta:', err);
      }
    });
  }

  checkExpiration() {
    if (this.tarjeta && this.tarjeta.endDate) {
      const expirationDate = new Date(this.tarjeta.endDate);
      const today = new Date();
      // Reset time to check only the dates
      expirationDate.setHours(23, 59, 59, 999);
      if (today > expirationDate) {
        this.isExpired = true;
      } else {
        this.isExpired = false;
      }
    }
  }

  checkForNotifications() {
    if (!this.profile || !this.profile.idCliente) return;

    // In this context, we check notifications using the idCliente.
    // We could filter by cardId if needed, but for now we get all for the client/card
    const cardId = (this.tarjeta?.id && this.tarjeta.id !== '0' && this.tarjeta.id !== 'test') ? this.tarjeta.id : undefined;

    this.notificationService.getNotifications(this.profile.idCliente, undefined, cardId)
      .subscribe({
        next: (notifications) => {
          let allData = notifications || [];

          if (this.isBrowserEnv) {
            const deletedKey = `deleted_notifications_${this.profile?.idCliente}_${this.tarjeta?.id || 'default'}`;
            const deletedStr = localStorage.getItem(deletedKey);
            let deletedIds: number[] = deletedStr ? JSON.parse(deletedStr) : [];
            allData = allData.filter(n => n.id && !deletedIds.includes(n.id));
          }

          this.notifications = allData;
          this.calculateUnread();
        },
        error: (err) => console.warn('Error fetching notifications:', err)
      });
  }

  calculateUnread() {
    if (!this.isBrowserEnv) return;

    const lastReadKey = `last_read_notifications_${this.profile?.idCliente}_${this.tarjeta?.id || 'default'}`;
    const lastReadDateStr = localStorage.getItem(lastReadKey);
    let lastReadDate = lastReadDateStr ? new Date(lastReadDateStr) : new Date(0);

    this.unreadCount = this.notifications.filter(n => {
      const createdAt = n.createdAt ? new Date(n.createdAt) : new Date();
      return createdAt > lastReadDate;
    }).length;
  }

  toggleNotificationsPanel() {
    this.showNotificationsPanel = !this.showNotificationsPanel;

    if (this.showNotificationsPanel && this.isBrowserEnv) {
      // Mark as read
      const lastReadKey = `last_read_notifications_${this.profile?.idCliente}_${this.tarjeta?.id || 'default'}`;
      localStorage.setItem(lastReadKey, new Date().toISOString());
      this.unreadCount = 0;
    }
  }

  deleteNotification(event: Event, notifId: number | undefined) {
    event.stopPropagation();
    event.preventDefault();

    if (!notifId || !this.isBrowserEnv) return;

    // Filter array
    this.notifications = this.notifications.filter(n => n.id !== notifId);

    // Save deleted ID to local storage
    const deletedKey = `deleted_notifications_${this.profile?.idCliente}_${this.tarjeta?.id || 'default'}`;
    const deletedStr = localStorage.getItem(deletedKey);
    let deletedIds: number[] = deletedStr ? JSON.parse(deletedStr) : [];

    if (!deletedIds.includes(notifId)) {
      deletedIds.push(notifId);
      localStorage.setItem(deletedKey, JSON.stringify(deletedIds));
    }
  }



  abrirPanel() {
    this.panelAbierto = !this.panelAbierto;
  }

  cerrarPanel() {
    this.panelAbierto = false;
  }

  enviarDatosExtra() {
    if (!this.termsAccepted) {
      return;
    }

    this.spinner.show();
    this.tarjetaService.sendConsulta(this.tarjeta.uid, this.formExtra).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.snackBar.open('Se ha enviado tu contacto.', 'Cerrar', { duration: 3000 });
        this.formExtra = {
          nombre: '',
          telefono: '',
          correo: '',
          empresa: '',
        };
        this.termsAccepted = false;
        this.panelAbierto = false;
      },
      error: (err) => {
        this.spinner.hide();
        this.snackBar.open('Error al enviar tu contacto.', 'Cerrar', { duration: 3000 });
      },
    });
  }

  showTerms(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    Swal.fire({
      title: 'Términos y Condiciones',
      html: `
        <div style="text-align: left; font-size: 12px; line-height: 1.45;">
          <p><strong>ACEPTO TÉRMINOS Y CONDICIONES / TRATAMIENTO DE DATOS PERSONALES</strong></p>
          <p>Al completar y enviar este formulario, usted autoriza de manera libre, informada, específica e inequívoca el tratamiento de sus datos personales por parte del titular de esta Tarjeta Digital y de la plataforma tecnológica utilizada para su gestión, conforme a la legislación vigente en Chile sobre protección de datos personales, incluyendo la Ley N° 19.628 y sus modificaciones, así como la nueva normativa de protección de datos personales aplicable desde el año 2026.</p>
          <p>Los datos solicitados, tales como nombre, teléfono, correo electrónico y empresa, serán utilizados exclusivamente para fines de contacto comercial, networking profesional, envío de información relacionada con productos o servicios, seguimiento comercial y gestión de relaciones profesionales o empresariales.</p>
          <p>La información proporcionada será almacenada de manera segura y no será vendida, cedida ni compartida con terceros no autorizados, salvo obligación legal o cuando sea estrictamente necesario para la correcta operación tecnológica de la plataforma.</p>
          <p>El usuario declara que los datos entregados son verídicos y acepta expresamente que estos puedan ser tratados mediante sistemas digitales y almacenados en servidores tecnológicos nacionales o internacionales que cumplan estándares adecuados de seguridad y confidencialidad.</p>
          <p>Asimismo, el titular de los datos podrá ejercer en cualquier momento sus derechos de acceso, rectificación, actualización, eliminación, oposición, portabilidad y demás derechos establecidos por la normativa vigente, solicitándolo directamente al titular de la Tarjeta Digital o mediante los canales de contacto informados en esta plataforma.</p>
          <p>Al presionar el botón “Enviar”, usted declara haber leído y aceptado estos Términos y Condiciones y la Política de Tratamiento de Datos Personales aplicable a esta plataforma.</p>
        </div>
      `,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Cerrar',
      allowOutsideClick: false,
      width: window.innerWidth < 768 ? '95%' : '800px',
      padding: '1em',
      heightAuto: false,
      customClass: {
        container: 'swal-mobile-container',
        popup: 'swal-mobile-popup',
        htmlContainer: 'swal-mobile-html-container',
        actions: 'swal-mobile-actions'
      }
    });
  }


  ngOnChanges(changes?: SimpleChanges) {
    if (changes?.['tarjeta']) {
      const previous = changes['tarjeta'].previousValue;
      const current = changes['tarjeta'].currentValue;
      if (previous?.imgProfile !== current?.imgProfile) {
        this.profileImageLoaded = false;
      }
    }
    if (changes?.['profile']) {
      const previous = changes['profile'].previousValue;
      const current = changes['profile'].currentValue;
      if (previous?.imgBanner !== current?.imgBanner) {
        this.bannerLoaded = false;
      }
      if (previous?.imgLogo !== current?.imgLogo) {
        this.logoLoaded = false;
      }
    }
    if (this.profile?.video) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.profile.video);
    }
    if (this.tarjeta) {
      this.setCargoHTML(this.tarjeta.cargo || '');
    }
  }

  updateMetaTags(): void {
    if (!this.tarjeta) {
      return;
    }

    const title = this.tarjeta?.nombre || 'Tarjeta Digital';
    const image = this.tarjeta?.imgProfileResize || this.tarjeta?.imgProfile || '';
    const url = this.tarjeta?.linkProfile || this.document?.location?.href || '';
    let description = '';
    const rawCargo = this.tarjeta?.cargo || '';

    if (rawCargo.includes('[SPORTS_CLUB]')) {
      try {
        const parts = rawCargo.split('[SPORTS_CLUB]');
        const jsonPart = parts[parts.length - 1].trim();
        try {
          const data = JSON.parse(jsonPart);
          description = `${data.cargo || ''}${data.institucion ? ' en ' + data.institucion : ''}`.trim();
        } catch (innerE) {
          // If the last part isn't valid JSON, try to clean what we have
          description = this.cleanHTMLReplace(rawCargo).replace(/\[SPORTS_CLUB\]/g, '').trim();
        }

        // Fallback if data is empty or malformed
        if (!description || description.startsWith('{')) {
          description = `${title} - Credencial Digital`;
        }
      } catch (e) {
        description = `${title} - Credencial Digital`;
      }
    } else {
      description = this.cleanHTMLReplace(rawCargo);
    }

    // Ultimo resguardo: si por alguna razon queda algo parecido a JSON, lo limpiamos
    if (description.includes('{"') || description.includes('"}')) {
      description = `${title} - Credencial Digital`;
    }

    // Cambiar el titulo de la pestana
    this.titleService.setTitle(`${title} - Tarjeta de Contacto`);

    // OpenGraph meta tags para compartir en redes sociales
    this.metaService.updateTag({ property: 'og:title', content: title });
    if (image) {
      this.metaService.updateTag({ property: 'og:image', content: image });
    }
    if (url) {
      this.metaService.updateTag({ property: 'og:url', content: url });
    }

    // Twitter meta tags
    this.metaService.updateTag({ name: 'twitter:title', content: title });
    if (image) {
      this.metaService.updateTag({ name: 'twitter:image', content: image });
    }
    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });

    if (this.isBrowserEnv && image) {
      this.updateOrCreateLink('shortcut icon', image, 'image/jpeg');
      this.updateOrCreateLink('image_src', image);
    }

    // Actualizar etiquetas meta
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
  }

  cleanHTMLToPreview(html: string): string {
    if (this.isBrowserEnv) {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || '';
    }
    return this.cleanHTMLReplace(html);
  }


  private updateOrCreateLink(rel: string, href: string, type?: string): void {
    let linkEl = this.document.querySelector(`link[rel='${rel}']`);
    if (linkEl) {
      this.renderer.setAttribute(linkEl, 'href', href);
      if (type) this.renderer.setAttribute(linkEl, 'type', type);
    } else {
      linkEl = this.renderer.createElement('link');
      this.renderer.setAttribute(linkEl, 'rel', rel);
      this.renderer.setAttribute(linkEl, 'href', href);
      if (type) this.renderer.setAttribute(linkEl, 'type', type);
      this.renderer.appendChild(this.document.head, linkEl);
    }
  }

  private resetImageLoadingState(): void {
    this.bannerLoaded = false;
    this.profileImageLoaded = false;
    this.logoLoaded = false;
  }

  markImageLoaded(type: 'banner' | 'profile' | 'logo'): void {
    if (type === 'banner') this.bannerLoaded = true;
    if (type === 'profile') this.profileImageLoaded = true;
    if (type === 'logo') this.logoLoaded = true;
  }

  compartir(): void {
    if (!this.isBrowserEnv) {
      return;
    }
    const url = window.location.href;
    const titulo = `${this.tarjeta?.nombre}`;
    const texto = `Accede a mi Tarjeta de Presentación Digital aquí: `;

    const isHuawei = /huawei/i.test(navigator.userAgent);

    if (navigator.share && !isHuawei) {
      navigator.share({
        title: titulo,
        text: texto,
        url: url
      }).then(() => {
        console.log('Compartido con éxito');
      }).catch((error) => {
        this.mostrarModalCompartir(url);
      });
    } else {
      this.mostrarModalCompartir(url);
    }
  }

  mostrarModalCompartir(url: string): void {
    this.urlParaCompartir = url;
    this.urlWhatsapp = `https://wa.me/?text=${encodeURIComponent(url)}`;
    this.urlEmail = `mailto:?subject=Tarjeta Digital&body=${encodeURIComponent(url)}`;
    this.mostrarModal = true;
    this.instruction = ''; // Reset instructions when opening modal
  }

  showInstruction(platform: string) {
    this.instruction = platform;
  }

  copiarEnlace(): void {
    if (!this.isBrowserEnv) {
      return;
    }
    navigator.clipboard.writeText(this.urlParaCompartir)
      .then(() => alert("Enlace copiado al portapapeles"))
      .catch(err => console.error("Error al copiar:", err));
  }

  descargarVCF(): void {
    if (!this.isBrowserEnv) {
      return;
    }
    const { nombre, telefono, correo, direccion, wsp, cargo, imgProfile, linkProfile, imgProfileResize, org } = this.tarjeta;

    fetch(imgProfileResize)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result?.toString().split(',')[1] || '';
          let tituloLimpio = this.cleanHTML(cargo || '').replace(/[\r\n]+/g, ' - ');
          if (this.isSportsClub && this.sportsData) {
            tituloLimpio = `${this.sportsData.cargo} - ${this.sportsData.institucion}`;
          }
          let vCardData = `BEGIN:VCARD
VERSION:3.0
PHOTO;ENCODING=BASE64;TYPE=JPEG:${base64data}
ORG;CHARSET=utf-8:${org}
N:${nombre}
FN:${nombre}
TITLE:${tituloLimpio}
TEL;TYPE=CELL,VOICE:${wsp}
EMAIL;INTERNET:${correo}
ADR;WORK;PREF:;${direccion}
URL;WORK:${linkProfile}

END:VCARD`;

          const vcfBlob = new Blob([vCardData], { type: 'text/vcard' });
          const vcfUrl = URL.createObjectURL(vcfBlob);
          const a = document.createElement('a');
          a.href = vcfUrl;
          a.download = `${nombre}.vcf`;
          a.click();
        };
      })
      .catch(error => console.error("Error al cargar la imagen:", error));
  }


  setCargoHTML(raw: string) {
    if (raw && raw.includes('[SPORTS_CLUB]')) {
      this.isSportsClub = true;
      try {
        const parts = raw.split('[SPORTS_CLUB]');
        if (parts.length > 1) {
          const jsonStr = parts[1].trim();
          this.sportsData = JSON.parse(jsonStr);
          this.cargoHTML = this.sanitizer.bypassSecurityTrustHtml('');
        }
      } catch (e) {
        console.error("Error parsing sports club data", e);
        this.isSportsClub = false;
        this.cargoHTML = this.sanitizer.bypassSecurityTrustHtml(raw || '');
      }
    } else {
      this.isSportsClub = false;
      this.sportsData = null;
      this.cargoHTML = this.sanitizer.bypassSecurityTrustHtml(raw || '');
    }
  }

  setTextoHTML(raw: string) {
    // si quieres, aquí puedes normalizar alineación a clases antes de confiar
    this.textoHTML = this.sanitizer.bypassSecurityTrustHtml(raw || '');
  }

  cleanHTMLReplace(html: string): string {
    return html?.replace(/<[^>]+>/g, '') || '';
  }

  cleanHTML(input: string): string {
    if (!this.isBrowserEnv) {
      return this.cleanHTMLReplace(input);
    }
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || '';
  }

  getProfile(codigo: any) {
    this.spinner.show();
    this.perfilService.getPerfilByCodeTarjeta(codigo).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.resetImageLoadingState();
        this.profile = response;
        this.ngOnChanges();
        this.setTextoHTML(this.profile?.texto || '');
        this.checkForNotifications();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar el perfil:', err);
      },
    });
  }

  getTarjeta(codigo: any) {
    this.spinner.show();
    this.tarjetaService.getTarjetaByCode(codigo).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.resetImageLoadingState();
        this.tarjeta = response;
        this.setCargoHTML(this.tarjeta?.cargo || '');
        this.updateMetaTags();
        this.checkExpiration();
        this.checkForNotifications();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar la tarjeta:', err);
      },
    });
  }

  getRedUrl(): string {
    return `https://v6card.com/public/client/${this.profile.idCliente}/network`;
  }

  //  getGoogleWalletUrl(codigo: any){
  //     this.spinner.show();
  //     this.tarjetaService.getGoogleWalletByCode(codigo).subscribe({
  //       next: (response) => {
  //         this.spinner.hide();
  //         this.googleWalletUrl = response
  //         console.log(this.googleWalletUrl)
  //       },
  //       error: (err) => {
  //         this.spinner.hide();
  //         console.error('Error al cargar la url del wallet:', err);
  //       },
  //     });
  //   }


  getCleanWsp(wsp: string): string {
    if (!wsp) return '';
    return wsp.replace(/\D/g, '');
  }

}
